module.exports = __webpack_public_path__ + "static/media/road.66a021ab.png";